export enum EMealSize {
	ALL = 'all',
	S_SIZE = 'sizeS',
	M_SIZE = 'sizeM',
	L_SIZE = 'sizeL',
	XL_SIZE = 'sizeXL',
}

export enum EMealSizePL {
	S_SIZE = 'Rozmiar S',
	M_SIZE = 'Rozmiar M',
	L_SIZE = 'Rozmiar L',
	XL_SIZE = 'Rozmiar XL',
}

export const EMealSizePLMap: Record<EMealSizePL, string> = {
	[EMealSizePL.S_SIZE]: 'S',
	[EMealSizePL.M_SIZE]: 'M',
	[EMealSizePL.L_SIZE]: 'L',
	[EMealSizePL.XL_SIZE]: 'XL',
}

export const MealSizeMap: Record<EMealSize, string> = {
	[EMealSize.ALL]: 'Wszystkie',
	[EMealSize.S_SIZE]: 'Rozmiar S',
	[EMealSize.M_SIZE]: 'Rozmiar M',
	[EMealSize.L_SIZE]: 'Rozmiar L',
	[EMealSize.XL_SIZE]: 'Rozmiar XL',
}

export enum EMealSizeWithoutAll {
	S_SIZE = 'sizeS',
	M_SIZE = 'sizeM',
	L_SIZE = 'sizeL',
	XL_SIZE = 'sizeXL',
}
